import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ClientPortal from "@/pages/ClientPortal";
export const Route = createFileRoute("/portal")({ head: ({match}) => pageHead(match.pathname), component: () => (<ClientPortal />) });
